export default {
  nome: {
    value: '',
    maxlength: '100',
    required: false,
    state: null
  },
  inative: {
    value: null,
    required: false,
    state: null
  }
}



// WEBPACK FOOTER //
// ./src/views/private/configurations/ajuizamento/prognostico/components/add/prognostico-form.js